import React from 'react'
import cn from 'classnames'

import { Text } from '@babylon/core-ui'
import { useProductConfig } from '@babylon/product-config'
import { formatClinician } from '../BookSlotDialog/BookSlotUtils'
import { Clinician, Slot } from './GroupSlots'

import styles from './AvailabilitySlots.module.css'

interface Props {
  active?: boolean
  disabled?: boolean
  clinicians?: Clinician[]
  time: string
  slot?: Slot
}

export const getSlotStyle = (slot: Slot, isNewSlotsEnabled: boolean) => {
  const defaultStyle = null
  if (Object.keys(slot).length > 0 && isNewSlotsEnabled) {
    if (slot.urgent) {
      return styles.slotUrgent
    } else if (slot.reserved) {
      return styles.slotReserved
    } else {
      return defaultStyle
    }
  } else {
    return defaultStyle
  }
}

const AvailabilitySlotContent = ({
  active = false,
  disabled = false,
  clinicians,
  time,
  slot = {} as Slot,
}: Props) => {
  const { getProp } = useProductConfig()
  const rebookingSlotTypesEnabled =
    getProp(
      'clinicalCare',
      'appointments.adminPortal.rebookingSlotTypesEnabled'
    ) || false
  return (
    <div
      className={cn(
        styles.slot,
        disabled && styles.slotDisabled,
        active && styles.slotActive,
        getSlotStyle(slot, rebookingSlotTypesEnabled)
      )}
    >
      <Text bold tag="div" className={styles.slotTime}>
        {time}
      </Text>

      {!disabled && clinicians && clinicians.length === 1 && (
        <Text tag="div" ellipsis>
          {formatClinician(clinicians[0])}
        </Text>
      )}

      {!disabled && clinicians && clinicians.length > 1 && (
        <Text tag="div" ellipsis>
          {clinicians.length} available
        </Text>
      )}
    </div>
  )
}

export default AvailabilitySlotContent
